import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Inpatient = () => {
  const [admissions, setAdmissions] = useState([]);
  const [beds, setBeds] = useState([]);
  const [wards, setWards] = useState([]);
  const [admissionForm, setAdmissionForm] = useState({
    patientId: '',
    bedId: '',
    admissionDate: '',
    diagnosis: '',
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [admissionsRes, bedsRes, wardsRes] = await Promise.all([
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/inpatient/admissions`),
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/inpatient/beds`),
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/inpatient/wards`),
      ]);
      setAdmissions(admissionsRes.data);
      setBeds(bedsRes.data);
      setWards(wardsRes.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAdmissionSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/inpatient/admissions`, admissionForm);
      setAdmissionForm({
        patientId: '',
        bedId: '',
        admissionDate: '',
        diagnosis: '',
      });
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  const handleAdmissionChange = (e) => {
    setAdmissionForm({ ...admissionForm, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <h2>Inpatient Management</h2>
      <h3>Admit Patient</h3>
      <form onSubmit={handleAdmissionSubmit}>
        <input name="patientId" placeholder="Patient ID" value={admissionForm.patientId} onChange={handleAdmissionChange} required />
        <select name="bedId" value={admissionForm.bedId} onChange={handleAdmissionChange} required>
          <option value="">Select Bed</option>
          {beds.filter(bed => !bed.isOccupied).map(bed => (
            <option key={bed.id} value={bed.id}>{bed.bedNumber} (Ward {bed.wardId})</option>
          ))}
        </select>
        <input name="admissionDate" type="date" value={admissionForm.admissionDate} onChange={handleAdmissionChange} required />
        <textarea name="diagnosis" placeholder="Diagnosis" value={admissionForm.diagnosis} onChange={handleAdmissionChange}></textarea>
        <button type="submit">Admit Patient</button>
      </form>
      <h3>Current Admissions</h3>
      <ul>
        {admissions.filter(ad => ad.status === 'admitted').map(admission => (
          <li key={admission.id}>
            Patient {admission.patientId} in Bed {admission.bedId} - Diagnosis: {admission.diagnosis}
          </li>
        ))}
      </ul>
      <h3>Available Beds</h3>
      <ul>
        {beds.filter(bed => !bed.isOccupied).map(bed => (
          <li key={bed.id}>Bed {bed.bedNumber} in Ward {bed.wardId}</li>
        ))}
      </ul>
    </div>
  );
};

export default Inpatient;